//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.GeometricConstraintDataManager.js";
import "../no/SelectDisplayableObject.js";
import "../no/SelectObject.js";
let d=[[[0,"Associative",1,0],[1,"ConstraintManager",0,"Features.GeometricConstraintDataManager",0],[0,"Direction",1,0],[0,"IsSpacingEnabled",1,0],[0,"IsSwitchDirection",1,0],[0,"IsUEnabled",1,0],[0,"IsVEnabled",1,0],[0,"Number",1,0],[0,"Placement",1,0],[1,"SelectObject",0,"SelectDisplayableObject",0],[0,"Spacing",1,0]],[[["points","masterPoint"],"SetActivePoints",{},2,0],[[],"UpdateIsoparametricCurves",{},0,0]],[]];
SPLM.Features.IsoparametricCurvesBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.IsoparametricCurvesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.IsoparametricCurvesBuilder.DirectionTypes = Object.freeze({
    "IsoU" : "IsoU", "IsoV" : "IsoV", "IsoUV" : "IsoUV"});

SPLM.Features.IsoparametricCurvesBuilder.PlacementTypes = Object.freeze({
    "Uniform" : "Uniform", "ThroughPoints" : "ThroughPoints", "BetweenPoints" : "BetweenPoints"});

export default SPLM;